import DeviceConfig from '@devices/config';
import { PlayerState } from '@shared/types/enums/player';
import { pause, play } from '@shared/store/slices/media.slice';
import { store } from '@shared/store/store';
import { useAppDispatch, useAppSelector } from '@shared/store/hooks';
import { useEffect } from 'react';
import {
  appSelector,
  disableNetwork,
  enableNetwork,
} from '@shared/store/slices/app.slice';

const CHECK_NETWORK_TIME = 30 * 1000;

const handlePlayerStatus = (status: boolean) => {
  const { media } = store.getState();
  if (!status) {
    if (media.state === PlayerState.PLAYING) store.dispatch(pause());
  } else {
    if (media.state === PlayerState.PAUSE) store.dispatch(play());
  }
};

// Check network status after 30s of disconnection and handle modal

export default function useNetwork() {
  const dispatch = useAppDispatch();
  const {
    status: { visibility, network },
  } = useAppSelector(appSelector);

  useEffect(() => {
    handlePlayerStatus(network);
  }, [network]);

  useEffect(() => {
    handlePlayerStatus(visibility);
    setTimeout(() => {
      if (visibility) {
        if (DeviceConfig.checkNetwork()) {
          dispatch(enableNetwork());
        } else {
          dispatch(disableNetwork());
        }
      }
    }, CHECK_NETWORK_TIME);
  }, [visibility]);

  return null;
}
